module.exports = __webpack_public_path__ + "static/media/icon-rental-app.ce114d9f.svg";